(() => {
  const initialise = () => document.querySelectorAll('[data-hh-us-slider]').forEach(root => {
    if (root.dataset.initialised) return;
    root.dataset.initialised = 'true';
    const slides = Array.from(root.querySelectorAll('[data-hh-us-slide]'));
    const controls = root.querySelector('[data-hh-us-controls]');
    const pause = root.querySelector('[data-hh-us-pause]');
    const counter = root.querySelector('[data-hh-us-counter]');
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = window.matchMedia('(max-width: 749px)');
    const template = counter.textContent;
    let index = 0, timer = null, stopped = false, hovered = false, focused = false;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => { slide.hidden = i !== index; });
      counter.textContent = template.replace('1', String(index + 1));
    };
    const update = () => {
      window.clearInterval(timer);
      const allowed = !stopped && !hovered && !focused && !document.hidden && !reduced.matches && !mobile.matches;
      pause.textContent = allowed ? pause.dataset.pauseLabel : pause.dataset.playLabel;
      pause.setAttribute('aria-pressed', String(stopped));
      counter.setAttribute('aria-live', allowed ? 'off' : 'polite');
      if (allowed) timer = window.setInterval(() => show(index + 1), 9000);
    };
    const manual = delta => { stopped = true; show(index + delta); update(); };
    root.querySelector('[data-hh-us-prev]').addEventListener('click', () => manual(-1));
    root.querySelector('[data-hh-us-next]').addEventListener('click', () => manual(1));
    pause.addEventListener('click', () => { stopped = !stopped; focused = false; update(); });
    root.addEventListener('mouseenter', () => { hovered = true; update(); });
    root.addEventListener('mouseleave', () => { hovered = false; update(); });
    root.addEventListener('focusin', () => { focused = true; stopped = true; update(); });
    root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) { focused = false; update(); } });
    document.addEventListener('visibilitychange', update);
    reduced.addEventListener('change', update);
    mobile.addEventListener('change', update);
    controls.hidden = false;
    show(0);
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise); else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
